<div class="drawer-container" [class.open]="isOpen">
    <div class="drawer-content">
      <div class="drawer-header">
        <h2>{{ 'tableView' | translate }}</h2>
        <button class="close-btn" (click)="closeDrawer()">&times;</button>
      </div>
      <div class="drawer-body">
        <div class="vehicle-state" *ngIf="pageType === 'tracker' && _service.rbacManagement('tracker_TrackerVehicleState')">
          <app-tracker-vehicle-state 
            [states]="states" 
            (selectedState)="handleStateSelection($event)" 
            [trackerFilters]="trackerFilters">
          </app-tracker-vehicle-state>
        </div>
        <div class="table-wrapper">
          <div class="export-border d-flex justify-content-end pr-2">
          </div>
          <app-common-table 
            [tableData]="masterLeafletData"
            [columnHeader]="tenantConfig?.trackerHeader ? tenantConfig?.trackerHeader : {}"
            [pageType]="tenantConfig?.tenant === 'TRL' ? 'trlWidget' : (tenantConfig?.tenant === 'VOT' ? 'validOpsTable' : 'otherTable')" 
            class="app-common-table"
            [actionPermission]="{geo: true, pagination: tenantConfig?.tenant === 'VOT' ? true : false}" 
            (tableAction)="onTableAction($event)"  
            [tableTitle]="trackerTabs?.tableView"  
            (pageSizeChange)="onPageSizeChange($event)">
          </app-common-table>
          <app-standard-pagination 
            [pagination]="pager" 
            backgroundColor="'#f8f8f8'"
            *ngIf="pager && pager?.pages?.length > 1 && tenantConfig?.tenant !== 'VOT'" 
            (paginationAction)="onPaginateChange($event)">
          </app-standard-pagination>
        </div>
      </div>
    </div>
    <div class="drawer-backdrop" (click)="closeDrawer()" *ngIf="isOpen"></div>
  </div>